import { render, staticRenderFns } from "./controlComponent.vue?vue&type=template&id=aa01fb38"
import script from "./controlComponent.vue?vue&type=script&lang=js"
export * from "./controlComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports